export default [
  'marcela@foodforjoe.es',
  'daniel@wedo-solutions.com',
  'office@wedo-solutions.com',
  'elena@foodforjoe.es',
  'paolo.troni@foodforjoe.es',
  'diego@foodforjoe.es',
];
